import firebase from "firebase/compat/app";
import { db } from "../firebase";

/**
 * Get header metrics settings for a user
 * @param {string} userId - The unique identifier for the user
 * @returns {Promise<Object>} Promise resolving to header metrics settings object
 */
export async function getHeaderMetricsSettings(userId) {
	if (!userId) {
		throw new Error("User ID is required");
	}

	try {
		const doc = await db
			.collection("Users")
			.doc(userId)
			.collection("Account")
			.doc("HeaderMetricsSettings")
			.get();

		if (doc.exists) {
			return doc.data();
		}
		return null;
	} catch (error) {
		console.error("[headerMetricsConfiguration][getHeaderMetricsSettings] - Error:", error);
		throw error;
	}
}

/**
 * Save header metrics settings for a user
 * @param {string} userId - The unique identifier for the user
 * @param {Object} settings - Settings object to save
 * @returns {Promise<void>}
 */
export async function saveHeaderMetricsSettings(userId, settings) {
	if (!userId) {
		throw new Error("User ID is required");
	}

	try {
		const settingsToSave = {
			...settings,
			updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
		};

		await db
			.collection("Users")
			.doc(userId)
			.collection("Account")
			.doc("HeaderMetricsSettings")
			.set(settingsToSave, { merge: true });

		console.log("[headerMetricsConfiguration][saveHeaderMetricsSettings] - Settings saved successfully");
	} catch (error) {
		console.error("[headerMetricsConfiguration][saveHeaderMetricsSettings] - Error:", error);
		throw error;
	}
}

